<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lF3btD/tc-custom/9780062311580.jpg?1730583381680" alt="This image is the cover for the book Welcome to the Goddamn Ice Cube"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Welcome to the Goddamn Ice Cube
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A rich and revelatory memoir of a young woman reclaiming her courage in the stark landscapes of the north.</b></p><p>By the time Blair Braverman was eighteen, she had left her home in California, moved to arctic Norway to learn to drive sled dogs, and found work as a tour guide on a glacier in Alaska. Determined to carve out a life as a “tough girl”—a young woman who confronts danger without apology—she slowly developed the strength and resilience the landscape demanded of her. </p><p>By turns funny and sobering, bold and tender, <i>Welcome to the Goddamn Ice Cube</i> brilliantly recounts Braverman’s adventures in Norway and Alaska. Settling into her new surroundings, Braverman was often terrified that she would lose control of her dog team and crash her sled, or be attacked by a polar bear, or get lost on the tundra. Above all, she worried that, unlike the other, gutsier people alongside her, she wasn’t cut out for life on the frontier. But no matter how out of place she felt, one thing was clear: she was hooked on the North. On the brink of adulthood, Braverman was determined to prove that her fears did not define her—and so she resolved to embrace the wilderness and make it her own. </p><p>Assured, honest, and lyrical, <i>Welcome to the Goddamn Ice Cube</i> paints a powerful portrait of self-reliance in the face of extraordinary circumstance. Braverman endures physical exhaustion, survives being buried alive in an ice cave, and drives her dogs through a whiteout blizzard to escape crooked police. Through it all, she grapples with love and violence—navigating a grievous relationship with a fellow musher, and adapting to the expectations of her Norwegian neighbors—as she negotiates the complex demands of being a young woman in a man’s land.</p><p>Weaving fast-paced adventure writing and ethnographic journalism with elegantly wrought reflections on identity, <i>Welcome to the Goddamn Ice Cube</i> captures the triumphs and the perils of Braverman’s journey to self-discovery and independence in a landscape that is as beautiful as it is unforgiving. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Blair Braverman
      </h2>
      
      <p class="authorDescription body article"><P>BLAIR BRAVERMAN is a writer, dogsledder, and adventurer who uses innovative storytelling to make the outdoors accessible. She is the author of <I>Welcome to the Goddamn Ice Cube, </I>a contributing editor to <I>Outside</I>&#160;magazine, and a contributor to <I>The</I>&#160;<I>New York Times, Vogue, This American Life, </I>and elsewhere. She lives in the northwoods with her husband, Quince Mountain, and their team of sled dogs.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ab24ea96